import React from "react";

// POS quantity multiplier (selectedProductQuantity): back arrow + 2x..5x chips + Custom. Tapping a
// product then adds `value` units. Clicking the active chip resets to 1.
// Shown above the product grid; scrolls horizontally on narrow screens rather than wrapping into a
// tall block that would eat the catalogue.
const MULTS = [2, 3, 4, 5]; // 2x–5x then Custom (user: 6x–11x dropped 08-27)

export default function MultiplierBar({ value, onSelect, onCustom, onBack, customQty = null }) {
  // Android setupCustomQuantityDialog: after Apply the chips DESELECT and the button reads "Custom (N)" —
  // even when N equals a chip value — until the next add resets it (resetQuantity → "Custom").
  const customActive = customQty != null && customQty > 0;
  const chipOn = (n) => !customActive && value === n;
  return (
    <div className="qv-multbar" role="group" aria-label="Quantity multiplier">
      <button type="button" className="qv-btn qv-btn--icon" onClick={onBack} title="Back to categories" aria-label="Back to categories">←</button>
      <div className="qv-multbar-scroll qv-scroll">
        {MULTS.map((n) => (
          <button
            key={n}
            type="button"
            className={chipOn(n) ? "qv-btn is-on qv-num" : "qv-btn qv-num"}
            aria-pressed={chipOn(n)}
            onClick={() => onSelect(chipOn(n) ? 1 : n)}
          >
            {n}x
          </button>
        ))}
        <button
          type="button"
          className={customActive ? "qv-btn is-on" : "qv-btn"}
          aria-pressed={customActive}
          onClick={onCustom}
        >
          {customActive ? `Custom (${customQty})` : "Custom"}
        </button>
      </div>
    </div>
  );
}
